<template>
  <v-select
    id="select"
    v-model="filter.IndicadorSubGrupo"
    item-text="nome"
    item-name="subGrupoIndicadorId"
    item-value="subGrupoIndicadorId"
    :items="subGrupoIndicador"
    label="SubGrupo"
    placeholder="SubGrupo"
    :disabled="disabled"
    @change="$emit('onChange')"
  >
    <template slot="no-data">
      Nada retornado
    </template>
  </v-select>
</template>

<script>
// import { subGrupoIndicadorAPI } from '../API/subGrupoIndicadorAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppSubGrupoIndicadorCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.load()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    load () {
      /*
      subGrupoIndicadorAPI.list()
        .then(resp => {
          this.subGrupoIndicador = resp.data
        })
        .catch()
      */
    }
  },
  data () {
    return {
      subGrupoIndicador: []
    }
  }
}
</script>
